import React from "react";
import Header from "../components/header";
import FooterNav from "../components/FooterNavbar";

const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col h-screen relative">
      {/* Fixed Header */}
      <div className="fixed top-0 left-0 right-0 z-20">
        <Header />
      </div>

      {/* Main Content */}
      <main className="flex-grow overflow-y-auto pt-[70px] pb-[65px] bg-white">
        {children}
      </main>

      {/* Fixed Footer */}
      <div className="fixed bottom-0 left-0 right-0 z-10">
        <FooterNav />
      </div>
    </div>
  );
};

export default MainLayout;
